
import { Component, ChangeDetectionStrategy, input, output, effect, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
// FIX: Corrected import path for models.
import { LoyaltyTier } from '../../models/index';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-tier-form-modal',
  standalone: true,
  templateUrl: './tier-form-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslatePipe],
})
export class TierFormModalComponent {
  tier = input<LoyaltyTier | null>();
  isOpen = input.required<boolean>();
  
  closeModal = output<void>();
  saveTier = output<Omit<LoyaltyTier, 'id' | 'createdAt'> | LoyaltyTier>();

  tierForm: FormGroup;

  constructor() {
    // FIX: Explicitly type FormBuilder to resolve an issue where inject() was returning 'unknown'.
    const fb: FormBuilder = inject(FormBuilder);
    this.tierForm = fb.group({
      id: [null],
      name: ['', Validators.required],
      min_points: [0, [Validators.required, Validators.min(0)]],
      icon: [''],
      benefits: [''],
    });

    effect(() => {
        const tierData = this.tier();
        if (tierData) {
            this.tierForm.patchValue(tierData);
        } else {
            this.tierForm.reset({
                id: null,
                name: '',
                min_points: 0,
                icon: '🥉',
                benefits: '',
            });
        }
    });
  }

  onClose(): void {
    this.closeModal.emit();
  }

  onSave(): void {
    if (this.tierForm.valid) {
      this.saveTier.emit(this.tierForm.value);
    }
  }

  onBackdropClick(event: MouseEvent): void {
      if (event.target === event.currentTarget) {
          this.onClose();
      }
  }
}
